<template>
  <div class="personality-magnetic-content" id="plataforma-de-marca-personalidade-magneticos-e-vibrantes" data-search-anchor>
    <div class="personality-magnetic-overlay-title-image">
      <h1 class="personality-magnetic-image-technology-title">
        {{ PersonalityMagneticImageTitle }}
      </h1>
      <p class="personality-magnetic-image-technology-text">
        {{ PersonalityMagneticImageTitle2}}
      </p>
    </div>

    <div
      class="personality-magnetic-banner-image"
      :style="{ backgroundImage: `url(${PersonalityMagneticImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonalityPageMixin from '@/mixins/personality-page-mixin'
import {PersonalityPageStore } from '@/store/brand-plataform-page/personality-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonalityMagnetictSection extends Mixins(PersonalityPageMixin) {
  personalityPageStore: PageStoreContract = getModule(PersonalityPageStore, this.$store)

  get PersonalityMagneticImageTitle(): string {
    return this.getElementText(6, 0)
  }

  get PersonalityMagneticImageSrc(): string {
    return this.getElementMedia(6, 0)
  }

  get PersonalityMagneticImageTitle2(): string {
    return this.getElementText(6, 1)
  }

  get PersonalityMagneticImageTitle3(): string {
    return this.getElementText(6, 2)
  }

  async getPersonalityPageStore(): Promise<void> {
    await this.personalityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personalityPageStore.isLoading) {
      await this.getPersonalityPageStore()
    }
  }
}
</script>

<style lang="scss">
.personality-magnetic-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;
  margin-bottom: 4rem;
}

.personality-magnetic-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.personality-magnetic-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.personality-magnetic-image-technology-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
  margin-bottom: 2rem;
  margin-top: 4rem;
}

.personality-magnetic-image-technology-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>